module.exports = __webpack_public_path__ + "static/img/thank_you.afd98ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/thank_you.png
// module id = iOJO
// module chunks = 134